export class JobTransactionLineRow {
  constructor(
    private jobId: number,
    private jobNumber: string,
    private lastUpdated: Date,
    private transactionId: number,
    private createdDateTime: Date,
    private amount: number,
    private isTransactionLine: boolean,
    private description: string,
  ) {
    this.jobId = jobId;
    this.jobNumber = jobNumber;
    this.transactionId = transactionId;
    this.lastUpdated = lastUpdated;
    this.createdDateTime = createdDateTime;
    this.amount = amount;
    this.isTransactionLine = isTransactionLine;
    this.description = description;
  }
}
